import { render, staticRenderFns } from "./data_final.vue?vue&type=template&id=5d93d198&scoped=true&"
import script from "./data_final.vue?vue&type=script&lang=js&"
export * from "./data_final.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d93d198",
  null
  
)

export default component.exports